<ui-section>
  <ui-block>
    <div class="platform-data-reset-admin">
      <ng-container *ngIf="canReset(); else noPermission">
        <div class="page-header">
          <div>
            <h2>Data Reset</h2>
            <p class="page-subtitle">
              Restore this demo environment to its seeded baseline. Frontend checks remain UX gates only;
              server-side authorization stays authoritative.
            </p>
          </div>
        </div>

        <div class="reset-explainer">
          <p>
            Resetting <strong>wipes all user-entered hearing data</strong>: all hearings, schedules,
            assignments, decisions, SDMF analyses, notes, and imported inmates.
            <strong>Documents are kept.</strong>
          </p>
          <p>
            It then <strong>restores the 15-inmate demo baseline</strong> centered on today: 3 completed
            hearings, 3 hearings scheduled 15 days out, 5 inmates assigned to the scheduler persona, and
            all hearing deadlines reset to 30 days out.
          </p>
          <p>
            Logins, feature flags, and terminology are <strong>preserved</strong> — no user accounts or
            configuration are touched.
          </p>
        </div>

        <div
          class="message-box success"
          *ngIf="result() as reset"
          role="status"
          aria-live="polite"
          data-testid="data-reset-result"
        >
          <p>
            Reset complete: {{ reset.inmates }} inmates, {{ reset.scheduledProceedings }} hearings,
            {{ reset.documents }} documents restored, centered on {{ reset.resetAtUtc | date: 'mediumDate' }}.
          </p>
          <p>Hard-refresh your browser (Ctrl+Shift+R) so cached terminology and configuration reload.</p>
        </div>

        <div class="message-box error" *ngIf="errorState() as error" role="alert" aria-live="assertive">
          <p>{{ error.title }}</p>
          <p *ngIf="error.detail">{{ error.detail }}</p>
        </div>

        <div class="reset-actions">
          <ui-button
            severity="danger"
            data-testid="data-reset-button"
            [buttonText]="busy() ? 'Resetting...' : 'Reset demo data'"
            [disabled]="busy()"
            (click)="confirmAndReset()"
          ></ui-button>
          <p class="busy-note" *ngIf="busy()" role="status" aria-live="polite">
            Resetting demo data. This can take a minute; do not close this page.
          </p>
        </div>
      </ng-container>

      <ng-template #noPermission>
        <p class="permission-note" data-testid="data-reset-permission-note">
          You do not have permission to reset demo data.
        </p>
      </ng-template>
    </div>
  </ui-block>
</ui-section>
